import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDatcrusherLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 41,
	viewBox: "0 0 40 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: -.00341797,
			y: .499023,
			width: 39.9873,
			height: 39.9873,
			rx: 9.59695,
			fill: "url(#paint0_linear_14582_33207)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .496423,
			y: .998865,
			width: 38.9876,
			height: 38.9876,
			rx: 9.09711,
			stroke: "white",
			strokeOpacity: .1,
			strokeWidth: .999683
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4355 10.4076H7.99414L16.851 20.3482L20.3401 16.7585L14.4355 10.4076Z",
			fill: "white",
			fillOpacity: .37
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4097 26.6987L20.3401 16.7581V23.6613L13.8987 30.2883L10.4097 26.6987Z",
			fill: "#C3C3C3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.2444 29.7366H32.6857L23.7664 20.2347L20.3398 23.6612L26.2444 29.7366Z",
			fill: "white",
			fillOpacity: .72
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.5387 13.5179L20.3398 23.6614V16.7582L26.9553 9.99585L30.5387 13.5179Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_14582_33207",
			x1: 19.9902,
			y1: 40.4863,
			x2: 19.9902,
			y2: .499023,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#111111" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#1D1D1D"
			})]
		}) })
	]
});
const ForwardRef = forwardRef(SvgDatcrusherLogo);
export { ForwardRef as ReactComponent };
